import { useTranslation } from "react-i18next";

import Button from "components/Button";
import { Link } from "react-router-dom";
import GetStarted from "components/GetStarted";
import { useGetStartedContext } from "context/GetStartedContextProvider";

const HeroSection = () => {
  const { t } = useTranslation("about");
  const { handleModalChange } = useGetStartedContext();

  return (
    <div className="my-[8rem]">
      <div className="flex justify-center items-center h-full mx-auto">
        <div className="w-[90%] xl:w-[92%] space-y-20">
          <div className="flex justify-between flex-col xl:flex-row  gap-10 items-center">
            <div className="space-y-3 xl:w-[50%]">
              <h6 className="text-[24px] font-light text-center md:text-left">
                {t("hero.minTitle")}
              </h6>
              <h1 className="text-black text-[36px] md:text-[52px] font-semibold w-full md:w-[80%] capitalize !leading-[62px] text-center md:text-left">
                {t("hero.title")}
              </h1>
            </div>
            <div className="space-y-5 xl:w-[50%]">
              <p className="text-[#00000066] text-[20px] text-center md:text-left">
                {t("hero.description")}
              </p>
              <div className="flex justify-left items-center flex-col md:flex-row gap-5">
                <Button
                  type="button"
                  text={t("button.demo")}
                  className="!px-6 !md:px-10"
                  size="sm"
                  onClick={() => handleModalChange(true)}
                />
                <Link
                  to="https://youtu.be/zjsAvAInW9Q?si=XHcznbIUBvLR1Yqy"
                  target="_blank"
                >
                  <Button
                    variant={"outlined"}
                    text={t("button.learnMore")}
                    className="!px-6 !md:px-10"
                    size="sm"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="relative w-full h-[350px] sm:h-[420px] lg:h-[500px] overflow-hidden rounded-xl">
            <iframe
              className="absolute top-1/2 left-1/2 w-[120%] h-[120%] -translate-x-1/2 -translate-y-1/2"
              src="https://www.youtube.com/embed/zjsAvAInW9Q?autoplay=1&mute=1&loop=1&playlist=zjsAvAInW9Q&controls=0&modestbranding=1&rel=0"
              title="About us video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        </div>
      </div>
      <GetStarted />
    </div>
  );
};
export default HeroSection;
